import { useConsentContext } from '@/hooks/use-consent-context';
import {
    ConsentContextProps,
    ConsentContextState,
} from '@rhg/hooks/use-consent-context/types';
import { PropsWithChildren, createContext } from 'react';

export const ConsentContext = createContext<ConsentContextState>(undefined!);

export function ConsentProvider({
    children,
    ...props
}: PropsWithChildren<ConsentContextProps>) {
    const state = useConsentContext(props);
    return (
        <ConsentContext.Provider value={state}>
            {children}
        </ConsentContext.Provider>
    );
}
